import React, { FunctionComponent, memo } from "react";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Button, Flex, IFlexProps } from "@/eworkitComponents";
import { useToggle } from "@/hooks/Toggle";
import { TColorVariant } from "@/style/colorVariants";

interface IJobRequestExpandableDetailIconSectionProps extends Partial<IFlexProps> {
  label: string;
  shortValue: string;
  longValue: string;
  buttonLabel: string;
  icon: string;
  isVisible?: boolean;
  iconColor?: TColorVariant;
}

export const JobRequestExpandableDetailIconSection: FunctionComponent<IJobRequestExpandableDetailIconSectionProps> =
  memo(props => {
    const {
      label,
      shortValue,
      longValue,
      buttonLabel,
      icon,
      isVisible = true,
      grow = 1,
      iconColor = "default",
    } = props;
    const [isExpanded, setExpanded] = useToggle(shortValue === longValue);

    if (!isVisible) {
      return null;
    }
    return (
      <Flex grow={grow} innerMargin="sm">
        <Flex justify="center" align="center">
          <Icon icon={icon} size="xl" color={iconColor} />
        </Flex>
        <Flex direction="column">
          <Text size="md" color="grey2">
            {label}
          </Text>
          {!isExpanded ? (
            <Flex direction="row">
              <Text size="md" color="black">
                {shortValue}
              </Text>
              <Button variant="link" className="expandable-button" onClick={setExpanded}>
                {buttonLabel}
              </Button>
            </Flex>
          ) : (
            <Text size="md" color="black">
              {longValue}
            </Text>
          )}
        </Flex>
      </Flex>
    );
  });
